import { Box } from '@inflearn/ds-react-next';

export const GeneratedHtml = ({ html }: { html: string }) => (
  <Box dangerouslySetInnerHTML={{ __html: html }} w="100%" miw={0} />
);
